import TopImageTitleAndShortDescription from "~/components/topImageTitleAndShortDescription"

export default function pagePrivacy() {
  return (
    <div className="bg-[#FEFEFE]">
      <TopImageTitleAndShortDescription
        title="Privacy Policy"
        shortDescription="How we collect, use, and protect your information"
        textColor="black"
        image="./terms-of-use.jpeg"
        bg_color="#FFFFFF80"
      />
      <div className="container mx-auto max-w-5xl space-y-5 p-5 py-5 md:py-16">
        <p>
          This privacy policy (Cambodia Carbon Registry Privacy Policy ) applies
          to all personal information collected by the Royal Government of
          Cambodia (RGC) , through the Ministry of Environment (MoE) , including
          without limitation, by way of the Cambodia Carbon Registry website
          located at [insert URL if applicable] (Website ).
        </p>
        <p>
          The Cambodia Carbon Registry (CCR) recognizes the importance of your
          privacy and that you have a right to control how your personal
          information is collected and used. We know that providing personal
          information is an act of trust, and we take that seriously. Unless you
          directly give us consent to do otherwise, the CCR will only collect
          and use your personal information as set out below.
        </p>

        <p className="font-bold">Collection of Information</p>
        <p>
          The CCR collects personal information from users of the Website,
          stakeholders, strategic partners, and other individuals. We collect
          this information when it is necessary for achieving the CCR’s mission
          of managing Green House Gas Emission Reduction (GHG ER) projects and
          facilitating the issuance, transfer, retirement, and cancellation of
          carbon credits.
        </p>
        <p>
          The CCR may collect personal information about you, including, for
          example:
          <ul>
            <li>
              Your contact details such as name, email address, phone number,
              mailing address;
            </li>
            <li>Employer and title;</li>
            <li>
              Any additional information required to verify identity or comply
              with Know-Your-Client (KYC) requirements. In particular, the CCR
              may collect personal information:
            </li>
            <li>
              When you use the Website, in which case our system may
              automatically collect information relating to your visit to that
              website, such as your IP address;
            </li>
            <li>
              When you fill in or complete reports, surveys, questionnaires, as
              well as contact and/or registration forms;
            </li>
            <li>
              When you upload or input information or documents to the Website;
            </li>
            <li>
              When you submit an application (and are authorized) to use any of
              our services; and/or
            </li>
            <li>
              During face-to-face meetings, email correspondence, or telephone
              conversations.
            </li>
          </ul>
        </p>
        <p>
          If you do not provide the CCR with all requested personal information,
          you may not be able to take full advantage of the CCR services or
          resources (including the provision of information and other services
          made available by way of the Website), to upload or input information
          to the Website, or to participate in GHG ER projects or related
          activities.
        </p>
        <p className="font-bold">Our Use of Cookies</p>
        <p>
          Cookies are pieces of information that a website transfers to your
          computer's hard drive for record-keeping purposes. Most web browsers
          are set to accept cookies. The CCR uses cookies to make your use of
          the Website, resources, and services as convenient as possible.
          Cookies in and of themselves do not personally identify users,
          although they do identify a user's browser. Cookies are useful to
          estimate the overall number of users of the Website and determine
          traffic patterns through the Website.
        </p>
        <p>
          If you do not wish to receive any cookies, you may set your browser to
          refuse cookies, but this may affect your ability to take full
          advantage of the services and resources on the Website.
        </p>
        <p className="font-bold">Using Your Personal Information</p>
        <p>
          Our purposes in collecting information about you can include:
          <ul>
            <li>
              Inviting you to participate in surveys, initiatives, or other
              activities related to GHG ER projects;
            </li>
            <li>
              Providing stakeholders with access to CCR services and resources;
            </li>
            <li>
              Compiling, managing, and analyzing reports, questionnaires, and
              surveys completed by you and producing reports based on your
              responses;
            </li>
            <li>
              Responding to stakeholder queries or requests for information that
              you may direct to us;
            </li>
            <li>Administering and maintaining the Website</li>
            <li>Improving CCR services and resources.</li>
          </ul>
        </p>
        <p className="font-bold">Disclosing Personal Information</p>

        <p>
          In order to deliver services and provide access to resources to you
          (including via the Website), and to improve those services and access,
          we may sometimes disclose your personal information to third parties
          such as:
          <ul>
            <li>
              Affiliates, partners, service providers, independent contractors,
              consultants, off-site security storage or IT providers, website
              hosts, and other partners of the CCR;
            </li>
            <li>
              Relevant government agencies, including international
              organizations like the United Nations Development Programme
              (UNDP), where required for compliance with applicable laws or
              regulations.
            </li>
          </ul>
        </p>
        <p>
          We may also share and disclose non-personal, de-identified, and
          aggregated information for the purposes of research and promotional
          activities. For example, we may disclose aggregated data from website
          visitor reports, event registrations, stakeholder queries, and surveys
          that you complete, and make such data available on the Website or
          through other mediums.
        </p>
        <p>
          In addition, the CCR may disclose personal information in connection
          with:
          <ul>
            <li>
              A sale or transaction involving all or a portion of the business;
            </li>
            <li>Where required by applicable law.</li>
          </ul>
        </p>

        <p className="font-bold">
          Storage and Security of Your Personal Information
        </p>
        <p>
          The CCR will endeavor to take all reasonable steps to keep secure any
          user information and to keep this information accurate and up to date.
          Your information is stored on secure servers that are protected in
          controlled facilities. We require our employees and data processors to
          respect the confidentiality of any personal information held by the
          CCR.
        </p>
        <p>
          Please note that the CCR may use overseas facilities to process or
          back up its information. As a result, we may transfer your personal
          information to overseas facilities for storage. However, this does not
          change any of our commitments to safeguard your privacy.
        </p>
        <p className="font-bold">Links to Other Websites</p>
        <p>
          The CCR provides, through the Website, access to third-party websites
          where content is not controlled by the CCR. These linked websites are
          not under the control of the CCR, and we are not responsible for the
          content or the conduct of the organizations accessed via links to such
          third-party websites through the Website. Before disclosing your
          personal information on any website, we suggest you examine the terms
          and conditions and privacy policy of that website.
        </p>
        <p className="font-bold">Future Changes</p>
        <p>
          The CCR may, from time to time, amend this Privacy Policy. Any such
          amendments will be posted on the Website and will take effect at least
          fourteen (14) days after such posting. Please therefore keep checking
          this CCR Privacy Policy to ensure you are aware of the terms of the
          current version.
        </p>
      </div>
    </div>
  )
}
